module.exports = __webpack_public_path__ + "static/img/news6.a48c02e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news6.png
// module id = +rde
// module chunks = 1